import React, { useState , useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Col } from "react-bootstrap";
import FormContainer from "../components/FormContainer";
import { useSelector, useDispatch } from "react-redux";
import { saveShippingAddress, savePaymentMethod } from "../redux/actions/cartActions";
import CheckoutSteps from "../components/CheckoutSteps";
import Message from "../components/Message";

const ShippingAndPaymentScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { shippingAddress, paymentMethod: savedPaymentMethod } = cart;

  const [address, setAddress] = useState(shippingAddress.address || "");
  const [city, setCity] = useState(shippingAddress.city || "");
  const [postalCode, setPostalCode] = useState(shippingAddress.postalCode || "");
  const [country, setCountry] = useState(shippingAddress.country || "");
  const [receiverContactNumber, setReceiverContactNumber] = useState(shippingAddress.receiverContactNumber || "");
  const [paymentMethod, setPaymentMethod] = useState(savedPaymentMethod || "UPI");
  const [message, setMessage] = useState("");
  const directPurchase = useSelector(state => state.directPurchase);

  const isDirectPurchase = directPurchase && directPurchase.product !== null;

  //changes for only COD
  useEffect(() => {
    if (savedPaymentMethod === "COD") {
      dispatch(savePaymentMethod("UPI"));
      setPaymentMethod("UPI");
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !address ||
      !city ||
      !postalCode ||
      !country ||
      !receiverContactNumber
    ) {
      setMessage("Please fill in all shipping address fields.");
      return;
    }

    // E.164 validation
    const e164Regex = /^\+[1-9]\d{1,14}$/;
    if (!e164Regex.test(receiverContactNumber)) {
      setMessage("Enter valid number in E.164 format. Example: +919876543210");
      return;
    }

    setMessage("");
    // Save shipping address
    dispatch(
      saveShippingAddress({
        address,
        city,
        postalCode,
        country,
        receiverContactNumber,
      }),
    );


    // Save payment method

    //changes for only COD
    if (paymentMethod === "COD") {
      setMessage("COD payments are temporarily unavailable. Please use UPI.");
      return;
    }

    dispatch(savePaymentMethod(paymentMethod));
    // Navigate to place order, replace history to avoid back to form
    navigate("/placeorder", { state: location.state }, { replace: true });
  };;

  return (
    <FormContainer>
      <CheckoutSteps step2/>
      {message && <Message variant="danger">{message}</Message>}
      <Form onSubmit={handleSubmit}>
        {/* Shipping Address Section */}
        <h4 style={{ justifySelf: "center" }}>------------ Shipping Address ------------</h4>
        
        <Form.Group className="py-2" controlId="address">
          <Form.Label>Address</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="py-2" controlId="city">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="py-2" controlId="postalcode">
          <Form.Label>Postal Code</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter postal code"
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="py-2" controlId="country">
          <Form.Label>Country</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="py-2" controlId="receiverContactNumber">
          <Form.Label>Receiver's Contact Number (e.g., +91xxxxxxxxxx)</Form.Label>
          <Form.Control
            type="text"
            placeholder="+919876543210"
            value={receiverContactNumber}
            onChange={(e) => {
              let val = e.target.value;

              val = val.replace(/\s+/g, ""); // remove spaces

              if (!val.startsWith("+")) {
                val = "+" + val.replace(/[^0-9]/g, "");
              } else {
                val = "+" + val.substring(1).replace(/[^0-9]/g, "");
              }

              setReceiverContactNumber(val);
            }}
          />
        </Form.Group>

        {/* Payment Method Section */}
        {/* <h4 className="mt-4" style={{ justifySelf: "center", marginBottom: "20px" }}>
          ------------ Payment Method ------------
        </h4>
        <Form.Group>
          <Form.Label as="legend" style={{ fontSize: "18px" }}>Choose an option:</Form.Label>
          <Col>
            <Form.Check
              type="radio"
              label="Cash on Delivery (COD)"
              id="COD"
              value="COD"
              name="paymentMethod"
              checked={paymentMethod === "COD"}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="my-2"
            />
            <Form.Check
              type="radio"
              label="UPI Payment"
              id="UPI"
              value="UPI"
              name="paymentMethod"
              checked={paymentMethod === "UPI"}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="my-2"
            />
          </Col>
        </Form.Group> */}

        <Button
          type="submit"
          variant="primary"
          className="mt-3 d-none d-md-block mx-auto"
        >
          Continue
        </Button>
        <Button
          type="submit"
          variant="primary"
          className="mt-3 d-block d-md-none ms-auto"
        >
          Continue
        </Button>
      </Form>
    </FormContainer>
  );
};

export default ShippingAndPaymentScreen;
